import * as React from "react";
import cx from "classnames";

import { PortfolioCategory } from "../../../models";
import { TrackClick } from "../../../hoc";

interface PortfolioFilterProps {
  portfolioCategory: PortfolioCategory;
  handleClick: () => void;
  active: boolean;
}

const getFilterClass = ({ active }: PortfolioFilterProps): string =>
  cx("portfolio-filter", {
    active: active,
  });

const PortfolioFilter = (props: PortfolioFilterProps) => (
  <li>
    <TrackClick
      category="landingpage"
      action="Filtered portfolio"
      label={props.portfolioCategory.name}
      onClick={props.handleClick}
      render={handleClick => (
        <a className={getFilterClass(props)} onClick={handleClick}>
          {props.portfolioCategory.name}
        </a>
      )}
    />
  </li>
);

export default PortfolioFilter;



// WEBPACK FOOTER //
// ./src/routes/PortfolioCarousel/components/PortfolioFilter.tsx